export const Application_Type = [
  {
    value: "Select an Institution and Offering",
    label: "Select an Institution and Offering",
  },
  {
    value:
      "South West TVET Institute – Newport Campus (2025-01-27 to 2026-03-31) - NVQJ Certificate",
    label:
      "South West TVET Institute – Newport Campus (2025-01-27 to 2026-03-31) - NVQJ Certificate",
  },
];

export const Gender_Type = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" }, 
];

export const Maritial_Status = [
  { value: "Single", label: "Single" },
  { value: "Widowed", label: "Widowed" },
  { value: "Married", label: "Married" },
  { value: "Divorced", label: "Divorced" },
  { value: "Spouse", label: "Spouse" },
];

export const RelationShip_Apllication = [
  { value: "Father", label: "Father" },
  { value: "Mother", label: "Mother" },
  { value: "Son", label: "Son" },
  { value: "Daughter", label: "Daughter" },
  { value: "Brother", label: "Brother" },
  { value: "Sister", label: "Sister" },
  { value: "Grandfather", label: "Grandfather" },
  { value: "Grandmother", label: "Grandmother" },
  { value: "Uncle", label: "Uncle" },
  { value: "Aunt", label: "Aunt" },
  { value: "Nephew", label: "Nephew" },
  { value: "Niece", label: "Niece" },
  { value: "Cousin", label: "Cousin" },
  { value: "Stepfather", label: "Stepfather" },
  { value: "Stepmother", label: "Stepmother" },
  { value: "Stepbrother", label: "Stepbrother" },
  { value: "Stepsister", label: "Stepsister" },
  { value: "Father-in-law", label: "Father-in-law" },
  { value: "Mother-in-law", label: "Mother-in-law" },
  { value: "Brother-in-law", label: "Brother-in-law" },
  { value: "Sister-in-law", label: "Sister-in-law" },
  { value: "Godfather", label: "Godfather" },
  { value: "Godmother", label: "Godmother" },
  { value: "Godson", label: "Godson" },
  { value: "Goddaughter", label: "Goddaughter" },
];

export const Examination_Bodies = [
  { value: "SAT", label: "Scholastic Assessment Test (SAT)" },
  { value: "ACT", label: "American College Testing (ACT)" },
  { value: "GRE", label: "Graduate Record Examination (GRE)" },
  { value: "GMAT", label: "Graduate Management Admission Test (GMAT)" },
  { value: "TOEFL", label: "Test of English as a Foreign Language (TOEFL)" },
  { value: "IELTS", label: "International English Language Testing System (IELTS)" },
  { value: "PTE", label: "Pearson Test of English (PTE)" },
  { value: "LSAT", label: "Law School Admission Test (LSAT)" },
  { value: "MCAT", label: "Medical College Admission Test (MCAT)" },
  { value: "USMLE", label: "United States Medical Licensing Examination (USMLE)" },
  { value: "CFA", label: "Chartered Financial Analyst (CFA)" },
  { value: "CPA", label: "Certified Public Accountant (CPA)" },
  { value: "CMA", label: "Certified Management Accountant (CMA)" },
  { value: "CISSP", label: "Certified Information Systems Security Professional (CISSP)" },
  { value: "NCLEX", label: "National Council Licensure Examination (NCLEX)" },
  { value: "GATE", label: "Graduate Aptitude Test in Engineering (GATE)" },
  { value: "UPSC", label: "Union Public Service Commission (UPSC)" },
  { value: "JEE", label: "Joint Entrance Examination (JEE)" },
  { value: "NEET", label: "National Eligibility cum Entrance Test (NEET)" },
  { value: "CBSE", label: "Central Board of Secondary Education (CBSE)" },
  { value: "ICSE", label: "Indian Certificate of Secondary Education (ICSE)" },
  { value: "IB", label: "International Baccalaureate (IB)" },
  { value: "IGCSE", label: "International General Certificate of Secondary Education (IGCSE)" },
  { value: "OET", label: "Occupational English Test (OET)" },
  { value: "HSC", label: "Higher Secondary Certificate (HSC)" },
  { value: "SSC", label: "Secondary School Certificate (SSC)" },
];


export const Skill_Areas = [
  { value: "Web_Development", label: "Web Development" },
  { value: "Mobile_Development", label: "Mobile Development" },
  { value: "UI_UX_Design", label: "UI/UX Design" },
  { value: "Data_Science", label: "Data Science" },
  { value: "Machine_Learning", label: "Machine Learning" },
  { value: "Cybersecurity", label: "Cybersecurity" },
  { value: "Cloud_Computing", label: "Cloud Computing" },
  { value: "DevOps", label: "DevOps" },
  { value: "Blockchain", label: "Blockchain" },
  { value: "AI_Artificial_Intelligence", label: "Artificial Intelligence (AI)" },
  { value: "Game_Development", label: "Game Development" },
  { value: "Digital_Marketing", label: "Digital Marketing" },
  { value: "SEO", label: "Search Engine Optimization (SEO)" },
  { value: "Graphic_Design", label: "Graphic Design" },
  { value: "Content_Writing", label: "Content Writing" },
  { value: "Project_Management", label: "Project Management" },
  { value: "Business_Analysis", label: "Business Analysis" },
  { value: "Finance", label: "Finance" },
  { value: "Accounting", label: "Accounting" },
  { value: "HR_Human_Resources", label: "Human Resources (HR)" },
  { value: "Sales", label: "Sales" },
  { value: "Customer_Service", label: "Customer Service" },
  { value: "Video_Editing", label: "Video Editing" },
  { value: "3D_Modeling", label: "3D Modeling" },
  { value: "Motion_Graphics", label: "Motion Graphics" },
  { value: "Photography", label: "Photography" },
  { value: "Music_Production", label: "Music Production" },
  { value: "Legal_Services", label: "Legal Services" },
  { value: "Medical_Research", label: "Medical Research" },
  { value: "Engineering", label: "Engineering" },
];

export const School_Types = [
  { value: "Public_School", label: "Public School" },
  { value: "Private_School", label: "Private School" },
  { value: "Charter_School", label: "Charter School" },
  { value: "Magnet_School", label: "Magnet School" },
  { value: "Boarding_School", label: "Boarding School" },
  { value: "Montessori_School", label: "Montessori School" },
  { value: "Religious_School", label: "Religious School" },
  { value: "Online_School", label: "Online School" },
  { value: "Vocational_School", label: "Vocational School" },
  { value: "Homeschool", label: "Homeschool" },
  { value: "International_School", label: "International School" },
  { value: "Special_Education_School", label: "Special Education School" },
  { value: "Alternative_School", label: "Alternative School" },
  { value: "STEM_School", label: "STEM School" },
  { value: "Military_School", label: "Military School" },
  { value: "Language_Immersion_School", label: "Language Immersion School" },
  { value: "Art_School", label: "Art School" },
  { value: "Music_School", label: "Music School" },
];

export const Award_Types = [
  { value: "Academic_Award", label: "Academic Award" },
  { value: "Sports_Award", label: "Sports Award" },
  { value: "Leadership_Award", label: "Leadership Award" },
  { value: "Community_Service_Award", label: "Community Service Award" },
  { value: "Innovation_Award", label: "Innovation Award" },
  { value: "Employee_of_the_Month", label: "Employee of the Month" },
  { value: "Best_Performer_Award", label: "Best Performer Award" },
  { value: "Excellence_Award", label: "Excellence Award" },
  { value: "Honorary_Award", label: "Honorary Award" },
  { value: "Lifetime_Achievement_Award", label: "Lifetime Achievement Award" },
  { value: "Scholarship_Award", label: "Scholarship Award" },
  { value: "Best_Teacher_Award", label: "Best Teacher Award" },
  { value: "Best_Student_Award", label: "Best Student Award" },
  { value: "Best_Research_Award", label: "Best Research Award" },
  { value: "Science_Award", label: "Science Award" },
  { value: "Technology_Award", label: "Technology Award" },
  { value: "Engineering_Award", label: "Engineering Award" },
  { value: "Mathematics_Award", label: "Mathematics Award" },
  { value: "Art_Award", label: "Art Award" },
  { value: "Music_Award", label: "Music Award" },
  { value: "Film_Award", label: "Film Award" },
  { value: "Literary_Award", label: "Literary Award" },
  { value: "Entrepreneurship_Award", label: "Entrepreneurship Award" },
  { value: "Customer_Service_Award", label: "Customer Service Award" },
  { value: "Safety_Award", label: "Safety Award" },
  { value: "Environmental_Award", label: "Environmental Award" },
  { value: "Best_Startup_Award", label: "Best Startup Award" },
];

export const Yearly_Awards = [
  { value: "Employee_of_the_Year", label: "Employee of the Year" },
  { value: "Student_of_the_Year", label: "Student of the Year" },
  { value: "Teacher_of_the_Year", label: "Teacher of the Year" },
  { value: "Athlete_of_the_Year", label: "Athlete of the Year" },
  { value: "Innovator_of_the_Year", label: "Innovator of the Year" },
  { value: "Entrepreneur_of_the_Year", label: "Entrepreneur of the Year" },
  { value: "Researcher_of_the_Year", label: "Researcher of the Year" },
  { value: "Leader_of_the_Year", label: "Leader of the Year" },
  { value: "Volunteer_of_the_Year", label: "Volunteer of the Year" },
  { value: "Artist_of_the_Year", label: "Artist of the Year" },
  { value: "Musician_of_the_Year", label: "Musician of the Year" },
  { value: "Writer_of_the_Year", label: "Writer of the Year" },
  { value: "Scientist_of_the_Year", label: "Scientist of the Year" },
  { value: "Technologist_of_the_Year", label: "Technologist of the Year" },
  { value: "Best_Startup_of_the_Year", label: "Best Startup of the Year" },
  { value: "CEO_of_the_Year", label: "CEO of the Year" },
  { value: "Company_of_the_Year", label: "Company of the Year" },
  { value: "Journalist_of_the_Year", label: "Journalist of the Year" },
  { value: "Filmmaker_of_the_Year", label: "Filmmaker of the Year" },
  { value: "Game_Developer_of_the_Year", label: "Game Developer of the Year" },
];
export const Document_Types = [
  { value: "birth_certificate", label: "Birth Certificate" },
  { value: "driving_license", label: "Driving License" },
  { value: "passport", label: "Passport" },
  { value: "college_degree", label: "College Degree" },
  { value: "social_security_card", label: "Social Security Card" },
  { value: "voter_id", label: "Voter ID" },
  { value: "residence_permit", label: "Residence Permit" },
];
export const SESSION_TYPES = [
  { value: "Agriculture, Forestry, and Fishing", name: "industry_sector" },
  { value: "Crop Production", name: "industry_sector" },
  { value: "Animal Husbandry", name: "industry_sector" },
  { value: "Aquaculture", name: "industry_sector" },
  { value: "Forestry and Logging", name: "industry_sector" },
  { value: "Mining and Extraction", name: "industry_sector" },
  { value: "Oil and Gas", name: "industry_sector" },
  { value: "Coal Mining", name: "industry_sector" },
  { value: "Metal Mining", name: "industry_sector" },
  { value: "Quarrying and Non-Metallic Mining", name: "industry_sector" },
  { value: "Manufacturing", name: "industry_sector" },
  { value: "Food and Beverage", name: "industry_sector" },
  { value: "Textiles and Apparel", name: "industry_sector" },
  { value: "Chemicals and Pharmaceuticals", name: "industry_sector" },
  { value: "Electronics and Appliances", name: "industry_sector" },
  { value: "Automotive", name: "industry_sector" },
  { value: "Furniture and Wood Products", name: "industry_sector" },
  { value: "Construction", name: "industry_sector" },
  { value: "Residential Construction", name: "industry_sector" },
  { value: "Commercial Construction", name: "industry_sector" },
  { value: "Infrastructure and Engineering", name: "industry_sector" },
  { value: "Specialized Trade Contractors", name: "industry_sector" },
  { value: "Utilities", name: "industry_sector" },
  { value: "Electricity", name: "industry_sector" },
  { value: "Water Supply and Sewerage", name: "industry_sector" },
  { value: "Renewable Energy", name: "industry_sector" },
  { value: "Transportation and Warehousing", name: "industry_sector" },
  { value: "Air Transportation", name: "industry_sector" },
  { value: "Rail Transportation", name: "industry_sector" },
  { value: "Trucking and Freight", name: "industry_sector" },
  { value: "Warehousing and Storage", name: "industry_sector" },
  { value: "Information Technology (IT)", name: "industry_sector" },
  { value: "Software Development", name: "industry_sector" },
  { value: "IT Services", name: "industry_sector" },
  { value: "Telecommunications", name: "industry_sector" },
  { value: "Cybersecurity", name: "industry_sector" },
  { value: "Finance and Insurance", name: "industry_sector" },
  { value: "Banking", name: "industry_sector" },
  { value: "Investment Services", name: "industry_sector" },
  { value: "Insurance Providers", name: "industry_sector" },
  { value: "Fintech", name: "industry_sector" },
  { value: "Real Estate", name: "industry_sector" },
  { value: "Residential Real Estate", name: "industry_sector" },
  { value: "Commercial Real Estate", name: "industry_sector" },
  { value: "Property Management", name: "industry_sector" },
  { value: "Real Estate Development", name: "industry_sector" },
  { value: "Healthcare and Social Assistance", name: "industry_sector" },
  { value: "Hospitals", name: "industry_sector" },
  { value: "Clinics and Outpatient Care", name: "industry_sector" },
  { value: "Pharmaceuticals", name: "industry_sector" },
  { value: "Assisted Living and Social Services", name: "industry_sector" },
  { value: "Retail and Wholesale", name: "industry_sector" },
  { value: "E-commerce", name: "industry_sector" },
  { value: "Grocery Stores", name: "industry_sector" },
  { value: "Fashion and Apparel", name: "industry_sector" },
  { value: "Electronics and Appliances", name: "industry_sector" },
  { value: "Hospitality and Tourism", name: "industry_sector" },
  { value: "Hotels and Resorts", name: "industry_sector" },
  { value: "Travel Agencies", name: "industry_sector" },
  { value: "Food and Beverage Services", name: "industry_sector" },
  { value: "Recreation and Leisure", name: "industry_sector" },
  { value: "Education", name: "industry_sector" },
  { value: "K-12 Education", name: "industry_sector" },
  { value: "Higher Education", name: "industry_sector" },
  { value: "Vocational Training", name: "industry_sector" },
  { value: "EdTech", name: "industry_sector" },
  { value: "Arts, Entertainment, and Recreation", name: "industry_sector" },
  { value: "Film and Media Production", name: "industry_sector" },
  { value: "Sports and Recreation", name: "industry_sector" },
  { value: "Museums and Historical Sites", name: "industry_sector" },
  { value: "Professional and Technical Services", name: "industry_sector" },
  { value: "Legal Services", name: "industry_sector" },
  { value: "Consulting Services", name: "industry_sector" },
  { value: "Architecture and Engineering", name: "industry_sector" },
  { value: "Marketing and Advertising", name: "industry_sector" },
  { value: "Public Administration", name: "industry_sector" },
  { value: "Government Agencies", name: "industry_sector" },
  { value: "Defense and Military", name: "industry_sector" },
  { value: "Public Safety", name: "industry_sector" },
  { value: "Non-Profit Organizations", name: "industry_sector" },
  { value: "Charitable Organizations", name: "industry_sector" },
  { value: "Foundations", name: "industry_sector" },
  { value: "Advocacy Groups", name: "industry_sector" },
  { value: "Personal Services", name: "industry_sector" },
  { value: "Beauty and Wellness", name: "industry_sector" },
  { value: "Household Services", name: "industry_sector" },
  { value: "Repair and Maintenance", name: "industry_sector" },
  { value: "Energy", name: "industry_sector" },
  { value: "Oil and Gas", name: "industry_sector" },
  { value: "Renewable Energy", name: "industry_sector" },
  { value: "Nuclear Energy", name: "industry_sector" },
  { value: "Other", name: "industry_sector" },
];

export const ETHNICITY_TYPES = [
  { value: "American Indian or Alaska Native", name: "ethnicity" },
  { value: "Asian", name: "ethnicity" },
  { value: "Black or African American", name: "ethnicity" },
  { value: "Native Hawaiian or Other Pacific Islander", name: "ethnicity" },
  { value: "White", name: "ethnicity" },
  { value: "Hispanic or Latino", name: "ethnicity" },
  { value: "African", name: "ethnicity" },
  { value: "Caribbean", name: "ethnicity" },
  { value: "Indian", name: "ethnicity" },
  { value: "Melanesian", name: "ethnicity" },
];


export const LANGUAGE_TYPES = [
  { value: "English", name: "language" },
  { value: "Spanish", name: "language" },
  { value: "Mandarin", name: "language" },
  { value: "French", name: "language" },
  { value: "German", name: "language" },
];

export const RELIGION_TYPES = [
  { value: "Christianity", name: "religion" },
  { value: "Islam", name: "religion" },
  { value: "Hinduism", name: "religion" },
  { value: "Buddhism", name: "religion" },
  { value: "Judaism", name: "religion" },
];












